import React from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from '@chakra-ui/react';
import { MdCategory } from 'react-icons/md';
import { PaginaDeportes } from '../_shared';
import TablaCatalogo, { CampoCatalogo } from './TablaCatalogo';

const COMUNES: CampoCatalogo[] = [
  { key: 'codigo', label: 'Código', requerido: true },
  { key: 'nombre', label: 'Nombre', requerido: true },
];

const disciplinasCampos: CampoCatalogo[] = [...COMUNES, { key: 'descripcion', label: 'Descripción', tipo: 'textarea' }];
const categoriasCampos: CampoCatalogo[] = [
  ...COMUNES,
  { key: 'edadMinima', label: 'Edad mínima', tipo: 'number' },
  { key: 'edadMaxima', label: 'Edad máxima', tipo: 'number' },
  { key: 'descripcion', label: 'Descripción', tipo: 'textarea' },
];
const ramasCampos: CampoCatalogo[] = [...COMUNES];
const catInvCampos: CampoCatalogo[] = [...COMUNES, { key: 'descripcion', label: 'Descripción', tipo: 'textarea' }];

const Catalogos: React.FC = () => (
  <PaginaDeportes
    icon={MdCategory}
    titulo="Catálogos de Deportes"
    subtitulo="Administración de disciplinas, categorías, ramas y categorías de inventario"
  >
    <Box bg="white" borderRadius="md" boxShadow="sm" p={4}>
      <Tabs colorScheme="red" variant="enclosed">
        <TabList>
          <Tab>Disciplinas</Tab>
          <Tab>Categorías</Tab>
          <Tab>Ramas</Tab>
          <Tab>Categoría de inventario</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}><TablaCatalogo recurso="disciplinas" titulo="Disciplinas" campos={disciplinasCampos} /></TabPanel>
          <TabPanel px={0}><TablaCatalogo recurso="categorias" titulo="Categorías" campos={categoriasCampos} /></TabPanel>
          <TabPanel px={0}><TablaCatalogo recurso="ramas" titulo="Ramas" campos={ramasCampos} /></TabPanel>
          <TabPanel px={0}><TablaCatalogo recurso="categoria-inventario" titulo="Categoría de inventario" campos={catInvCampos} /></TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  </PaginaDeportes>
);

export default Catalogos;
